import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=fb3e1cf8&scoped=true&"
import script from "./AlertIcon.vue?vue&type=script&lang=js&"
export * from "./AlertIcon.vue?vue&type=script&lang=js&"
import style0 from "./AlertIcon.vue?vue&type=style&index=0&id=fb3e1cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3e1cf8",
  null
  
)

export default component.exports